<template>
  <div v-if="body_show" class="bodys">
    <public-header :colors="'#f0f0f0'" :headimg="data.userdetail.headimgurl"></public-header>
    <div class="report_top" v-if="data.score!='' || data.assist_remark!=''">
      <img src="@a/report_h2.png" class="report_h2" />
      <div class="report_mb">
        <div ref="rew" class="report_m">
          <div class="report_tv clearfix">
            <div class="tv_l clearfix">
              <img :src="data.userdetail.headimgurl" />
              <div class="tv_lt">
                <h1>{{data.admission.name}}</h1>
                <h2>{{data.admission.career}}</h2>
                <h2>{{data.admission.job}}</h2>
              </div>
            </div>
            <img :src="data.score" class="tv_img" v-if="data.score!=''" />
          </div>
          <div class="report_bv">{{data.assist_remark}}</div>
        </div>
      </div>
    </div>
    <!-- 海报显示 -->
    <div class="report_main">
      <div v-for="(item,index) in data.report" :key="index">
        <img :src="item" :class="['report_img',index==0?'mt0':'']"  @click="img_preview(index)" />
        <h5>*长按卡片可保存</h5>
      </div>
    </div>
  </div>
</template>
<script>
import { getselfreport } from "@/api/course";
import { ImagePreview } from "vant";
import { shareCon } from "@/utils/wxconfig";
import wx from "weixin-js-sdk"
export default {
  data() {
    return {
      cid: "",
      data: {},
      body_show: false,
      report_mh: 0
    };
  },
  methods: {
    addTag() {},
    pullData() {
      getselfreport({
        cid: this.$route.query.cid,
        cpid: this.$route.query.cpid
      }).then(data => {
        document.title = data.name + "报告";
        this.body_show = true;
        this.data = data;
      });
    },
    img_preview(num) {
      let ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        wx.previewImage({
          current: this.data.report[num], // 当前显示图片的http链接
          urls:this.data.report // 需要预览的图片http链接列表
        });
      } else {
        ImagePreview({
          images: this.data.report,
          startPosition: num,
          showIndex: false,
          onClose() {
            // do something
          }
        });
      }
    }
  },
  created() {
    this.pullData();
    shareCon("course", this);
  }
};
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.bodys {
  padding-bottom: 55px;
  background-color: #fff;
}
.pd_auto {
  padding: 30px;
}
.report_top {
  width: changeRem(13.8) + px;
  margin: 0 auto;
  margin-top: changeRem(1.6) + px;
  background: linear-gradient(
    0deg,
    rgba(235, 80, 50, 1) 0%,
    rgba(245, 127, 23, 1) 100%
  );
  border-radius: changeRem(0.12) + px;
  padding: changeRem(0.48) + px changeRem(0.6) + px;
  text-align: center;
  position: relative;
  padding-bottom: 30px;
  margin-bottom: changeRem(0.5) + px;
  img.report_h2 {
    width: changeRem(9.12) + px;
    margin-top: 0;
    top: changeRem(-0.74) + px;
    position: absolute;
    left: 50%;
    margin-left: changeRem(-4.56) + px;
  }
  .report_mb {
    background: #ebebeb;
    width: changeRem(12.32) + px;
    height: auto;
    z-index: 1;
    margin-top: 64px;
    .report_m {
      margin: 0 auto;
      margin-top: changeRem(0.8) + px;
      margin-left: changeRem(0.4) + px;
      width: changeRem(12.32) + px;
      padding: changeRem(0.56) + px;
      padding-right: changeRem(0.68) + px;
      height: auto;
      background: rgba(255, 255, 255, 1);
      z-index: 2;
      position: relative;
      transform: translateX(changeRem(0.1) + px)
        translateY(changeRem(-0.4) + px);
      .report_tv {
        border-bottom: 2px dashed #ccc;
        padding-bottom: changeRem(0.48) + px;
        .tv_l {
          float: left;
          width: changeRem(9) + px;
          overflow: hidden;
          img {
            width: changeRem(2) + px;
            height: changeRem(2) + px;
            border-radius: 50%;
            float: left;
          }
          .tv_lt {
            margin-left: changeRem(0.44) + px;
            float: left;
            text-align: left;
            width: changeRem(6.5) + px;
            h1 {
              color: #333;
              font-size: changeRem(0.64) + px;
              line-height: changeRem(0.8) + px;
            }
            h2 {
              color: #333;
              font-size: changeRem(0.52) + px;
              line-height: changeRem(0.65) + px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: 100%;
            }
          }
        }
      }
      .report_bv {
        margin-top: changeRem(0.48) + px;
        color: #333;
        font-size: changeRem(0.52) + px;
        line-height: changeRem(0.8) + px;
        text-align: justify;
      }
    }
  }
}

.report_main {
  background: #fff;
  text-align: left;
  img.report_img {
    width: 100%;
    height: auto;
    vertical-align: middle;
    margin-top: changeRem(0.6) + px;
  }
  img.report_img.mt0{
    margin-top: 0px;
  }
  h5 {
    color: #333;
    font-size: changeRem(0.48) + px;
    padding-right: changeRem(0.6) + px;
    margin-top: changeRem(0.2) + px;
    margin-bottom: changeRem(0.2) + px;
    text-align: right;
    width: 100%;
  }
}
.tv_img {
  float: right;
  width: 100px;
}
</style>
